// Action Types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const UPDATE_USER = 'UPDATE_USER'

// Action Creators
export const loginSuccess = (userData) => ({
  type: LOGIN_SUCCESS,
  payload: userData
})

export const logout = () => ({
  type: LOGOUT
})

export const updateUser = (userData) => ({
  type: UPDATE_USER,
  payload: userData
})